import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from "react-helmet-async";

import "@fontsource/poppins";
import "@fontsource/poppins/500.css";
import "@fontsource/poetsen-one";

// // Google Tag Manager
// const GTM_ID = "GTM-WZF7VG47";

// (function (w, d, s, l, i) {
//   w[l] = w[l] || [];
//   w[l].push({
//     "gtm.start": new Date().getTime(),
//     event: "gtm.js",
//   });

//   const f = d.getElementsByTagName(s)[0];
//   const j = d.createElement(s);
//   const dl = l !== "dataLayer" ? "&l=" + l : "";

//   j.async = true;
//   j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;

//   f.parentNode.insertBefore(j, f);
// })(window, document, "script", "dataLayer", GTM_ID);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
